import React from "react";
import Layout from "../components/Layout/Layout";
import { Link } from "react-router-dom";
import { useCategory } from "../hooks/useCategory";
const Categories = () => {
  const categories = useCategory();
  return (
    <Layout title={"All Categories"}>
      <div className="container " style={{ marginTop: "100px" }}>
        <div className="row container">
          {categories.map((item) => (
            <div className="col-md-6 mt-4 mb-3 gx-3 gy-3" key={item._id}>
              <div
                className="card"
                style={{
                  height: "100px",
                  width: "250px",
                  cursor: "pointer",
                }}
              >
                <Link
                  to={`/category/${item.slug}`}
                  className="btn cat-btn text-center"
                >
                  {item.name}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Categories;
